<template>
  <div class="box" v-on:keyup.enter="submit">
    ABCDo is under construction. Please come back later to sign up.
    <!--
    <div class="field">
      <label class="label">Email</label>
      <div class="control">
        <input
          class="input"
          v-bind:class="blurEmail"
          v-model="email"
          type="email"
          placeholder="superhero@abcdo.org"
          value=""
          @blur="emailNotBlurredYet = false"
        />
      </div>
      <p
        class="help"
        v-show="!emailNotBlurredYet && !emailValid"
        v-bind:class="blurEmail"
      >
        This email is invalid
      </p>
      <p class="help" v-show="!(!emailNotBlurredYet && !emailValid)"></p>
    </div>
    <div class="field">
      <label class="label">Password</label>
      <div>Must have at least 8 characters</div>
      <div class="control">
        <input
          class="input"
          v-bind:class="blurPassword"
          v-model="password"
          type="password"
          placeholder=""
          @blur="passwordNotBlurredYet = false"
        />
      </div>
      <p class="help is-danger">{{ firebaseLoginError }}</p>
    </div>
    <a class="button" :disabled="!valid" @click="submit">
      Submit
    </a>
    -->
  </div>
</template>

<script>
export default {
  name: "JoinForm",
  components: {},
  data() {
    return {
      emailValid: false,
      emailNotBlurredYet: true,
      passwordValid: false,
      passwordNotBlurredYet: true,
      valid: false,
      email: "",
      password: ""
    };
  },
  methods: {
    submit() {
      if (this.valid) {
        this.$store.dispatch({
          type: "userJoin",
          email: this.email,
          password: this.password
        });
      }
    },
    updateValid() {
      this.valid = this.emailValid && this.passwordValid;
    }
  },
  watch: {
    email() {
      this.emailValid = /.+@.+\..+$/.test(this.email);
      this.updateValid();
    },
    password() {
      this.passwordValid = this.password.length >= 8;
      this.updateValid();
    }
  },
  computed: {
    blurEmail() {
      return {
        "is-danger": !this.emailNotBlurredYet && !this.emailValid
      };
    },
    blurPassword() {
      return {
        "is-danger": !this.passwordNotBlurredYet && !this.passwordValid
      };
    },
    firebaseLoginError() {
      return this.$store.state.firebaseLoginError;
    }
  },
  destroyed() {
    this.$store.commit("setFirebaseLoginError", { code: "null" });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.label {
  text-align: left;
}
.tabs {
  background-color: white;
}
</style>
